import { render, staticRenderFns } from "./DeskNotes.vue?vue&type=template&id=b3df22f4"
import script from "./DeskNotes.vue?vue&type=script&lang=js"
export * from "./DeskNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports